import type { Optional } from '@festina-life/core'
import {
  FPlusCodeContainer,
  type FPlusViewerAlignment,
} from '@festina-life/fplus'

import { FPlusViewerContents } from './FPlusViewerContents'
import type { FPlusExpressionProps } from './types'

type Props = FPlusExpressionProps & {
  alignment: FPlusViewerAlignment
  isShowingFunctionDeclaration: boolean
  overflowTitle?: Optional<string>
  shouldShowOverflowFallback: boolean
}

export const FPlusExpressionViewer = ({
  isTransparent,
  expression,
  alignment,
  isShowingFunctionDeclaration,
  path,
  typeInformation,
  shouldShowOverflowFallback,
}: Props) => (
  <FPlusCodeContainer isTransparent={isTransparent}>
    <FPlusViewerContents
      shouldShowOverflowFallback={shouldShowOverflowFallback}
      expression={expression}
      path={path}
      alignment={alignment}
      isShowingFunctionDeclaration={isShowingFunctionDeclaration}
      typeInformation={typeInformation}
    />
  </FPlusCodeContainer>
)
